import { IconChevronDown } from '@tabler/icons-react';
import classNames from 'classnames';

import styles from './pf-select.module.css';
import { PfSelectPickerModal } from './pf-select-picker-modal';
import type { PfSelectOption } from './pf-select.types';
import { useIonModalProps } from './use-ion-modal-props';

const PICKER_MODAL_OPTIONS = { cssClass: 'page-modal' };

export interface PfSelectTypeaheadFieldProps {
  label?: string;
  ariaLabel?: string;
  placeholder: string;
  options: PfSelectOption[];
  value?: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  error?: string;
  disabled?: boolean;
  wrapperClassName?: string;
}

export function PfSelectTypeaheadField({
  label,
  ariaLabel,
  placeholder,
  options,
  value,
  onChange,
  onBlur,
  error,
  disabled,
  wrapperClassName,
}: PfSelectTypeaheadFieldProps) {
  const { open: openPicker } = useIonModalProps(
    PfSelectPickerModal,
    PICKER_MODAL_OPTIONS
  );

  const selectedLabel =
    value != null && value !== ''
      ? options.find((option) => String(option.value) === value)?.label
      : null;

  return (
    <div className={classNames(styles.field, wrapperClassName)}>
      {label ? (
        <label className={styles.label} htmlFor={`pf-select-${label}`}>
          {label}
        </label>
      ) : null}
      <button
        aria-haspopup="dialog"
        aria-label={ariaLabel ?? label}
        className={classNames(styles.trigger, {
          [styles.triggerError]: Boolean(error),
        })}
        disabled={disabled}
        id={label ? `pf-select-${label}` : undefined}
        type="button"
        onClick={() =>
          openPicker({
            title: label ?? ariaLabel ?? '',
            options,
            selectedValue: value ?? '',
            onPick: (picked) => {
              onChange(picked);
              onBlur?.();
            },
          })
        }
      >
        <span
          className={classNames(styles.triggerValue, {
            [styles.triggerPlaceholder]: !selectedLabel,
          })}
        >
          {selectedLabel ?? placeholder}
        </span>
        <IconChevronDown className={styles.triggerIcon} size={18} stroke={1.75} />
      </button>
      {error ? <span className={styles.error}>{error}</span> : null}
    </div>
  );
}
